module.exports = __webpack_public_path__ + "img/zec.4775683f.svg";